export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="font-heading text-xl font-black text-background-50">91免费</span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              高清影视在线平台，汇聚91免费在线视频、91免费电影等免费资源，支持高清在线播放，整合最新免费电影在线观看与热门视频网站推荐。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-200 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">专题合集</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">热门排行</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">热门话题</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-200 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              感谢所有合作伙伴的支持。合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-200 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-background-400">
                <i className="ri-mail-line mr-2"></i>
                contributor@91free.com
              </li>
              <li className="text-sm text-background-400">
                <i className="ri-wechat-line mr-2"></i>
                91免费影视
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 91免费. 本站资源均来自公开平台，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">首页</a>
            <a href="#about" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
            <a href="#faq" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}